import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Avatar,
    Typography,
    Button,
    Grid,
    IconButton,
} from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import ComponentImageUploadWithCrop from "../../common/ComponentImageUploadWithCrop";

export default function ProfileImageUploadModal({
    isOpen,
    onClose,
    currentImage,
    userName,
    onSave,
}) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        return () => {
            if (previewImage) {
                URL.revokeObjectURL(previewImage);
            }
        };
    }, [previewImage]);

    const handleFileChange = (files) => {
        if (!files || files.length === 0) {
            setSelectedFile(null);
            setPreviewImage(null);
            return;
        }
        const firstFile = files[0];

        const imageUrl = firstFile?.cloudinary?.secure_url

        setSelectedFile(imageUrl);
        setPreviewImage(imageUrl);
    };

    const handleSave = () => {
        if (selectedFile) {
            onSave(selectedFile);
        }
        handleClose();
    };

    const handleClose = () => {
        if (previewImage) {
            URL.revokeObjectURL(previewImage);
        }
        setSelectedFile(null);
        setPreviewImage(null);
        onClose();
    };

    const getInitials = (name) => {
        return name
            .split(" ")
            .map((word) => word.charAt(0))
            .join("")
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle style={{ textAlign: "center", fontWeight: "bold" }}>
                Update profile picture
                <IconButton
                    onClick={handleClose}
                    style={{ position: "absolute", right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container direction="column" alignItems="center" spacing={2}>
                    <Grid item>
                        <Avatar
                            src={previewImage || currentImage}
                            alt={userName}
                            sx={{ width: 96, height: 96, fontSize: 32 }}
                        >
                            {getInitials(userName)}
                        </Avatar>
                    </Grid>
                    <Grid item>
                        <Typography variant="body2" color="textSecondary">
                            {userName}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} style={{ width: "100%" }}>
                        <ComponentImageUploadWithCrop
                            imageType="PROFILE"
                            onChange={handleFileChange}
                        />
                        <Typography variant="body2" color="textSecondary">
                            Image specifications: min width 180px | min height 180px | max size 2 mb | webp, jpg, png
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleClose} color="inherit">
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant="contained"
                    disabled={!selectedFile}
                    startIcon={<Check />}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}